import React from 'react';
import { Dialog, Image, T } from '@colonist/ui';
import RoomGameSpeeds from '@static/images/room_game_speeds.png';
import styles from './GameSpeedInfoDialog.module.scss';
export const GameSpeedInfoDialog = ({ open, onClose })=>{
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:roomPage.turnTimers'
        }
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement(Image, {
        className: styles.image,
        image: {
            src: RoomGameSpeeds,
            alt: 'strings:roomPage.turnTimers'
        }
    })), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        onClick: onClose
    })));
};
